// extracted by mini-css-extract-plugin
module.exports = {"root":"container_root__XdFYp","_variant-full":"container__variant-full__XyQHS","_variant-wide":"container__variant-wide__57F57"};